// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Erwartungswert, ErwartungswertDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateErwartungswert(): (
  aufgabeId: string,
  unteraufgabeId: string,
  erwartungswertId: string,
  requestBody: ErwartungswertDaten
) => Promise<Erwartungswert> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, unteraufgabeId, erwartungswertId, requestBody) =>
      (await getAPI()).erwartungswerte.updateErwartungswert({
        aufgabeId,
        unteraufgabeId,
        erwartungswertId,
        requestBody,
      }),
    [getAPI]
  );
}
